import React from 'react';
import { UserMenuConsumer } from '../context/UserMenuContext';
import styled from '@emotion/styled';
import UserHeader from './UserHeader';
import UserActions from './UserActions';
import EmailDetail from './EmailDetail';
import TeamDetail from './TeamDetail';
import CountryDetail from './CountryDetail';

const Container = styled.div`
  padding: 1.25rem;
  background: #57a8e6;
  height: calc(100vh - 4.3125rem);
`;

const Panel = styled.section<{ active: boolean }>`
  position: absolute;
  top: 3.75rem;
  right: 0;
  width: 25rem;
  max-width: 26.875rem;
  background: #57a8e6;
  transition: transform 300ms ease;
  z-index: 25;

  transform: ${p => (p.active ? 'translate(0)' : 'translate(100%)')};
`;

const DetailList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  @media screen and (max-width: 540px) {
    text-align: left;
  }
`;

export type UserInfo = {
  name: string;
  role: string;
  email: string;
  teamName: string;
  countryName: string;
};

export interface Props {
  userInfo: UserInfo;
}

const UserPanel = (props: Props) => {
  const { name, role, email, teamName, countryName } = props.userInfo;
  return (
    <UserMenuConsumer>
      {({ state }) => (
        <Panel data-testid="user-panel-panel" active={state.active}>
          <UserHeader userName={name} userRole={role} />
          <Container>
            <DetailList>
              <UserActions />
              {email && <EmailDetail email={email} />}
              {teamName && <TeamDetail teamName={teamName} />}
              {countryName && <CountryDetail countryName={countryName} />}
            </DetailList>
          </Container>
        </Panel>
      )}
    </UserMenuConsumer>
  );
};

export { UserPanel, UserPanel as default };
